import { useState } from "react";
import Layout from "@/components/Layout";
import { PageHero } from "@/components/PageHero";
import { PageDecorations } from "@/components/Decorations";

const Privacy = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Layout>
      <PageHero>Tietosuojaseloste</PageHero>

      <section
        className="relative overflow-hidden px-6 py-16 lg:px-10"
        style={{
          background:
            "linear-gradient(180deg, hsl(39,82%,92%) 0%, hsl(42,86%,78%) 100%)",
        }}
      >
        <PageDecorations />
        <div className="relative mx-auto max-w-3xl">
          <article className="rounded-2xl border border-border/40 bg-card/80 p-6 shadow-sm md:p-10">
            <h1 className="mb-6 text-center font-display text-3xl font-bold italic md:text-4xl" style={{ color: 'hsl(220, 70%, 20%)' }}>
              Tietosuojaseloste
            </h1>

            {!expanded ? (
              <>
                <div className="relative max-h-[420px] overflow-hidden">
                  <div className="space-y-4 leading-relaxed text-foreground/85">
                    <p>
                      Tämä tietosuojaseloste kertoo, mitä henkilötietoja <strong>Lotta Ellosen</strong> kampanjatyö-, viestintä-, ja markkinointierkisteriin
                      kerätään ja miten niitä käsitellään.
                    </p>
                    <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                      Kuka on rekisterinpitäjä ja mihin voit olla tarvittaessa
                      yhteydessä?
                    </h3>
                    <p>
                      <span className="font-semibold uppercase">Rekisterinpitäjä:</span>{" "}
                      Sinisellä Sydämellä ry
                      <br />
                      <span className="font-semibold uppercase">E-mail:</span>{" "}
                      sinisellasydamella@gmail.com
                    </p>
                    <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                      Mitä henkilötietoja käsitellään ja miksi?
                    </h3>
                    <p>Käsittelemme seuraavia sinulta saamiamme henkilötietoja:</p>
                  </div>
                  <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-card" />
                </div>
                <div className="mt-6 flex justify-center">
                  <button
                    type="button"
                    onClick={() => setExpanded(true)}
                    className="rounded-full bg-primary px-6 py-2.5 text-sm font-semibold uppercase tracking-wider text-primary-foreground shadow-sm transition hover:brightness-95"
                  >
                    Lue lisää
                  </button>
                </div>
              </>
            ) : (
              <div className="space-y-4 leading-relaxed text-foreground/85">
                <p>
                  Tämä tietosuojaseloste kertoo, mitä henkilötietoja <strong>Lotta Ellosen</strong> kampanjatyö-, viestintä-, ja markkinointierkisteriin
                  kerätään ja miten niitä käsitellään.
                </p>

                <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                  Kuka on rekisterinpitäjä ja mihin voit olla tarvittaessa
                  yhteydessä?
                </h3>
                <p>
                  <span className="font-semibold uppercase">Rekisterinpitäjä:</span>{" "}
                  Sinisellä Sydämellä ry
                  <br />
                  <span className="font-semibold uppercase">E-mail:</span>{" "}
                  sinisellasydamella@gmail.com
                </p>

                <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                  Mitä henkilötietoja käsitellään ja miksi?
                </h3>
                <p>Käsittelemme seuraavia sinulta saamiamme henkilötietoja:</p>
                <ul className="list-disc space-y-1 pl-6">
                  <li>Nimi</li>
                  <li>Yhteystiedot</li>
                  <li>Asuinkunta</li>
                  <li>Osallistumishalukkuus vaalityöhön</li>
                  <li>Suostumus henkilötietojen käsittelyyn</li>
                </ul>
                <p>
                  Henkilötietoja käytämme Lotta Ellosen sekä hänen
                  tukiyhdistyksensä Sinisellä Sydämellä ry:n viestintään sekä
                  kampanjointi- ja markkinointitoimenpiteisiin.
                </p>
                <p>
                  Käsitellyt henkilötiedot on kerätty sinulta itseltäsi, ja
                  käsittelemme niitä antamasi suostumuksen perusteella.
                </p>

                <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                  Kuka tietoja käsittelee ja siirretäänkö niitä EU:n tai
                  Euroopan talousalueen ulkopuolelle?
                </h3>
                <p>
                  Henkilötietojasi käsittelee ensisijaisesti Lotta Ellonen,
                  hänen kampanjansa aktiivit sekä Sinisellä Sydämellä ry:n
                  toimijat. Lisäksi henkilötietoja voivat käsitellä Lotta
                  Ellosen nettisivujen ylläpitoon osallistuvat henkilöt.
                </p>

                <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                  Kuinka kauan henkilötietoja säilytetään?
                </h3>
                <p>
                  Henkilötietojasi säilytetään enintään siihen asti, kunnes
                  peruutat suostumuksesi niiden käsittelyyn. Suostumuksen
                  peruuttamisen jälkeen henkilötiedot poistetaan
                  mahdollisimman pian, kuitenkin viimeistään kuukauden
                  kuluessa.
                </p>

                <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                  Mitä oikeuksia sinulla on?
                </h3>
                <p>Voit milloin tahansa pyytää meitä:</p>
                <ul className="list-disc space-y-1 pl-6">
                  <li>
                    vahvistamaan, käsittelemmekö sinua koskevia henkilötietoja,
                    sekä pyytämään niistä kopion
                  </li>
                  <li>korjaamaan mahdolliset virheelliset henkilötietosi</li>
                  <li>poistamaan henkilötietosi</li>
                  <li>rajoittamaan henkilötietojesi käsittelyä</li>
                </ul>
                <p>
                  Tässä kohdassa tarkoitetut pyynnöt voit tehdä sähköpostitse
                  osoitteeseen sinisellasydamella@gmail.com
                </p>
                <p>
                  Mikäli et ole tyytyväinen pyyntösi perusteella tekemäämme
                  ratkaisuun tai olet sitä mieltä, että tietosuojaan liittyviä
                  oikeuksiasi on loukattu, voit tehdä valituksen paikalliselle
                  tietosuojaviranomaiselle. Suomessa tietosuojaviranomaisena
                  toimii <a href="https://tietosuoja.fi/etusivu" target="_blank" rel="noopener noreferrer" className="font-bold text-secondary underline underline-offset-2 hover:no-underline">tietosuojavaltuutettu</a>.
                </p>

                <h3 className="pt-2 text-2xl font-bold text-secondary" style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}>
                  Muutokset tähän tietosuojaselosteeseen
                </h3>
                <p>
                  Tätä tietosuojaselostetta voidaan päivittää aika ajoin
                  esimerkiksi lainsäädännön muuttuessa. Tämä tietosuojaseloste
                  on viimeksi päivitetty 23.4.2026.
                </p>

                <div className="flex justify-center pt-4">
                  <button
                    type="button"
                    onClick={() => setExpanded(false)}
                    className="rounded-full bg-primary px-6 py-2.5 text-sm font-semibold uppercase tracking-wider text-primary-foreground shadow-sm transition hover:brightness-95"
                  >
                    Näytä vähemmän
                  </button>
                </div>
              </div>
            )}
          </article>
        </div>
      </section>
    </Layout>
  );
};

export default Privacy;
